@if ($nestedRail()) {
  <div class="detail-rail-guest">
    <!-- Title + tags on row 1 with close; commands on row 2. -->
    <header class="detail-rail-guest-head">
      <div class="detail-title-block">
        <div class="detail-title-row">
          @if ($showPaneBack()) {
            <wb-button-icon class="detail-pane-back" iconLeft="fa-regular fa-arrow-left" displayStyle="Tertiary" size="Small" [tooltip]="$paneBackLabel()" (onClick)="onPaneBack()" />
          }
          <h2 class="detail-title">
            <span #titleText="truncatedText" class="detail-identifier" truncatedText [tooltip]="$title()" [display]="titleText.$truncated()">{{ $title() }}</span>
          </h2>
        </div>
        @if ($headerTags().length > 0) {
          <div class="detail-tag-row">
            @for (tag of $headerTags(); track tag.key) {
              @if (tag.style) {
                <wb-badge [label]="tag.label" mode="squared" [color]="tag.style.color" [backgroundColor]="tag.style.backgroundColor" [borderColor]="tag.style.borderColor" [tooltip]="tag.tooltip" />
              } @else {
                <wb-badge [label]="tag.label" mode="squared" [tooltip]="tag.tooltip" />
              }
            }
          </div>
        }
        <!-- After the tags, so a status that comes and goes takes title room and never moves the commands. -->
        @if ($headerSlot().length > 0) {
          <div class="detail-header-slot">
            @for (item of $headerSlot(); track item.key) {
              <ng-container *ngComponentOutlet="item.component" />
            }
          </div>
        }
        <!-- Trailing chrome: close, fixed top-right on the title line. -->
        <div class="detail-header-chrome">
          <wb-surface-capability-region [fields]="$capabilityFields()" [surfaceMode]="$surfaceMode()" />
          <button type="button" class="detail-rail-guest-close" aria-label="Close" (click)="onClose()">
            <i class="fa-regular fa-xmark" aria-hidden="true"></i>
          </button>
        </div>
        <div class="detail-header-break" aria-hidden="true"></div>
      </div>
      <div class="detail-header-actions">
        @if ($headerActionCommands().length > 0) {
          <wb-action-bar [commands]="$headerActionCommands()" />
        }
      </div>
    </header>
    <ng-container [ngTemplateOutlet]="detailTabsTpl" />
    <ng-container [ngTemplateOutlet]="detailBodyTpl" />
  </div>
} @else {
<w-page [mode]="$pageMode()" [headerSize]="PageHeaderSize.Small" [hideHeader]="$hideHeader()" [hideFooter]="true" [forceShowClose]="$showClose()" closeIcon="fa-regular fa-xmark" (close)="onClose()" [class.has-rail]="$showRail()" [class.rail-collapsed]="$railCollapsed() && !$railPinned()" [class.rail-pinned]="$railPinned() && $railDockMode()" class="detail-frame" styleClass="surface-detail-frame">

  <!-- Narrow: title + tags on row 1 with pin/close; commands on row 2.
       Wide: one inline title line. -->
  <ng-container *w-page-header-title>
    <div class="detail-title-block">
      <div class="detail-title-row">
        <!-- No stepper on a nested pane (← back shown): it would step the parent board, not this record's siblings. -->
        @if (!$showPaneBack() && $panelControls().step; as step) {
          <!-- Leading, so the arrows stay put while the title length changes between records. -->
          <div class="detail-panel-stepper">
            <wb-button-icon iconLeft="fa-regular fa-chevron-up" displayStyle="Tertiary" size="Small" [tooltip]="$panelControls().hold ?? 'Previous record'" [disabled]="step.previousDisabled" (onClick)="onPanelStep(-1)" />
            <wb-button-icon iconLeft="fa-regular fa-chevron-down" displayStyle="Tertiary" size="Small" [tooltip]="$panelControls().hold ?? 'Next record'" [disabled]="step.nextDisabled" (onClick)="onPanelStep(1)" />
            @if (step.label; as label) {
              <span class="detail-panel-step-position">{{ label }}</span>
            }
          </div>
        }
        @if ($showPaneBack()) {
          <wb-button-icon class="detail-pane-back" iconLeft="fa-regular fa-arrow-left" displayStyle="Tertiary" size="Small" [tooltip]="$paneBackLabel()" (onClick)="onPaneBack()" />
        }
        <h2 class="detail-title">
          <span #titleText="truncatedText" class="detail-identifier" truncatedText [tooltip]="$title()" [display]="titleText.$truncated()">{{ $title() }}</span>
        </h2>
      </div>
      @if ($headerTags().length > 0) {
        <div class="detail-tag-row">
          @for (tag of $headerTags(); track tag.key) {
            @if (tag.style) {
              <wb-badge [label]="tag.label" mode="squared" [color]="tag.style.color" [backgroundColor]="tag.style.backgroundColor" [borderColor]="tag.style.borderColor" [tooltip]="tag.tooltip" />
            } @else {
              <wb-badge [label]="tag.label" mode="squared" [tooltip]="tag.tooltip" />
            }
          }
        </div>
      }
      <!-- After the tags, so a status that comes and goes takes title room and never moves the commands. -->
      @if ($headerSlot().length > 0) {
        <div class="detail-header-slot">
          @for (item of $headerSlot(); track item.key) {
            <ng-container *ngComponentOutlet="item.component" />
          }
        </div>
      }
      <!-- Trailing chrome: expand/dock, record page, pin, then w-page's own close. Top-right at every width. -->
      @if ($showPanelChrome()) {
        <div class="detail-header-chrome">
          @if ($panelControls().expand; as tooltip) {
            <wb-button-icon class="detail-panel-presentation" iconLeft="fa-regular fa-up-right-and-down-left-from-center" displayStyle="Tertiary" size="Small" [tooltip]="$panelControls().hold ?? tooltip" (onClick)="onPanelExpand()" />
          }
          @if ($panelControls().dock) {
            <wb-button-icon class="detail-panel-presentation" iconLeft="fa-regular fa-down-left-and-up-right-to-center" displayStyle="Tertiary" size="Small" [tooltip]="$panelControls().hold ?? 'Dock to side'" (onClick)="onPanelDock()" />
          }
          @if ($panelControls().openPage) {
            <wb-button-icon class="detail-panel-presentation" iconLeft="fa-solid fa-arrow-up-right-from-square" displayStyle="Tertiary" size="Small" [tooltip]="$panelControls().hold ?? 'Open record page'" (onClick)="onOpenRecordPage()" />
          }
          @if ($showPanelPin()) {
            <wb-button-icon class="detail-panel-pin" [iconLeft]="$panelPinIcon()" displayStyle="Tertiary" size="Small" [disabled]="$panelPinDisabled()" [tooltip]="$panelPinTooltip()" (onClick)="onTogglePanelPin()" />
          }
        </div>
      }
      <!-- Row break for the narrow header. Inert and zero-sized at host width; the
           container query gives it a full-width basis to start row 2. -->
      <div class="detail-header-break" aria-hidden="true"></div>
    </div>
  </ng-container>

  <ng-container *w-page-header-actions>
    <div class="detail-header-actions">
      @if ($headerActionCommands().length > 0) {
        <wb-action-bar [commands]="$headerActionCommands()" />
      }
      <!-- Last, so capability controls sit beside w-page's own close. -->
      <wb-surface-capability-region [fields]="$capabilityFields()" [surfaceMode]="$surfaceMode()" />
    </div>
  </ng-container>

  <ng-container *w-page-body-header>
    <ng-container [ngTemplateOutlet]="detailTabsTpl" />
  </ng-container>

  <ng-container *w-page-body-content>
    <ng-container [ngTemplateOutlet]="detailBodyTpl" />
  </ng-container>

  @if ($showRail()) {
    <ng-container *w-page-body-right-content>
      <wb-surface-rail [title]="$railTitle()" [(collapsed)]="$railCollapsed" [pinAvailable]="$railDockMode()" [(pinned)]="$railPinned">
        <ng-template #railContent>
          @if ($target(); as target) {
            <div class="detail-rail-hosted">
              <surface-engine #nestedSurface [entity]="target.entity" [entityId]="target.id" [operation]="target.operation" [params]="target.params" />
            </div>
          } @else {
            @for (item of $railSections(); track item.section.path) {
              @if (item.spacer) {
                <div class="section-spacer" aria-hidden="true"></div>
              } @else {
                <wb-section [path]="item.section.path" [title]="item.$title()" [description]="item.section.description" [columns]="item.section.columns" [layout]="item.section.layout" [collapsible]="item.section.collapsible" [collapsedByDefault]="item.section.collapsedByDefault" [collapsedSummary]="item.section.collapsedSummary" [readonly]="$page().section(item.section.path).$readonly()" [fields]="item.fields" [fieldGroups]="item.fieldGroups" [related]="item.section.related" [repeats]="item.repeats" [resolver]="item.resolver" [customRenderer]="item.customRenderer" [customRendererInputs]="item.customRendererInputs" [surfaceMode]="$surfaceMode()" [page]="$page()" />
              }
            }
          }
        </ng-template>
      </wb-surface-rail>
    </ng-container>
  }

</w-page>
}

<ng-template #detailTabsTpl>
  @if ($showTabStrip()) {
    <wb-tab-shell class="detail-tabs" [tabs]="$tabDeclarations()" [selectedTab]="$selectedTab()" [renderPanels]="false" (selectedTabChange)="onSelectedTabChange($event)" />
  }
</ng-template>

<ng-template #detailBodyTpl>
  <div class="detail-body" [class.is-custom-tab]="$activeTabInfo()?.tab?.type === 'custom'" [class.is-relation-tab]="$activeTabInfo()?.tab?.type === 'relation'">
    @if ($page().$surfaceErrors().length > 0) {
      <div class="detail-errors" role="alert">
        @for (error of $page().$surfaceErrors(); track error.code) {
          <p>{{ error.message }}</p>
        }
      </div>
    }

    @if ($activeTabInfo(); as info) {
      @if (info.tab.type === 'relation') {
        <div class="detail-tab-relation">
          @if (info.mount; as mount) {
            <ng-container [ngComponentOutlet]="mount.component" [ngComponentOutletInputs]="mount.inputs()" [ngComponentOutletInjector]="mount.injector" />
          }
        </div>
      } @else if (info.tab.type === 'custom' && info.custom; as custom) {
        <ng-container [ngComponentOutlet]="custom.component" [ngComponentOutletInputs]="custom.inputs()" />
      }
    }

    <div class="detail-sections" cdkAccordion [multi]="true">
    @for (band of $bodyLayout(); track $index) {
      @if (band.type === 'columns') {
        <!-- A lone column subgrids into .detail-sections (stylesheet); an inline track list would override that. -->
        <div class="section-columns" [style.grid-template-columns]="band.columns.length > 1 ? 'repeat(' + band.columns.length + ', minmax(0, 1fr))' : null">
          @for (column of band.columns; track $index) {
            <div class="section-column">
              @for (entry of column; track entry.key) {
                @if (entry.grouped) {
                  <div class="section-group">
                    @for (item of entry.items; track item.section.path) {
                      <ng-container [ngTemplateOutlet]="sectionItemTpl" [ngTemplateOutletContext]="{ $implicit: item }" />
                    }
                  </div>
                } @else {
                  <ng-container [ngTemplateOutlet]="sectionItemTpl" [ngTemplateOutletContext]="{ $implicit: entry.items[0] }" />
                }
              }
            </div>
          }
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="sectionItemTpl" [ngTemplateOutletContext]="{ $implicit: band.section }" />
      }
    }
    </div>
  </div>
</ng-template>

<ng-template #sectionItemTpl let-item>
  @if (item.spacer) {
    <div class="section-spacer" [class.is-gap]="item.section.layout === 'gap'" aria-hidden="true"></div>
  } @else if (item.section.related) {
    <wb-section [path]="item.section.path" [title]="item.$title()" [columns]="item.section.columns" [layout]="item.section.layout" [readonly]="$page().section(item.section.path).$readonly()" [fields]="item.fields" [fieldGroups]="item.fieldGroups" [related]="item.section.related" [repeats]="item.repeats" [resolver]="item.resolver" [customRenderer]="item.customRenderer" [customRendererInputs]="item.customRendererInputs" [surfaceMode]="$surfaceMode()" [page]="$page()" />
  } @else {
    <wb-section [path]="item.section.path" [title]="item.$title()" [description]="item.section.description" [columns]="item.section.columns" [layout]="item.section.layout" [collapsible]="item.section.collapsible" [collapsedByDefault]="item.section.collapsedByDefault" [collapsedSummary]="item.section.collapsedSummary" [readonly]="$page().section(item.section.path).$readonly()" [fields]="item.fields" [fieldGroups]="item.fieldGroups" [repeats]="item.repeats" [resolver]="item.resolver" [customRenderer]="item.customRenderer" [customRendererInputs]="item.customRendererInputs" [surfaceMode]="$surfaceMode()" [page]="$page()" />
  }
</ng-template>
